export enum EMaterialSlot
{
    Box = 0,
    Front = 1,
    SideRight = 2,
    SideLeft = 3,
    Inside = 4,
    Filler = 5,
    Door = 6,
    Plinth = 7,
    Groove = 8,
    SidePanel = 9,
    Outline = 10,
    Worktop = 11,
    Panel = 12,
    Door2 = 13
}